import { CustomDatePicker } from "./custom-date-picker";

type CustomDateRangePickerProps = {
  onClick: () => void;
  onFromDateChange: (date: Date) => void;
  selectedFromDate?: Date;
  onToDateChange: (date: Date) => void;
  selectedToDate?: Date;
  unrestricted?: boolean;
};

export const CustomDateRangePicker = ({
  onClick,
  onFromDateChange,
  selectedFromDate,
  onToDateChange,
  selectedToDate,
  unrestricted,
}: CustomDateRangePickerProps) => (
  <div className="flex-col w-[18.5rem]">
    <div className="mx-2 mb-2 font-semibold">From</div>
    <CustomDatePicker
      onClick={onClick}
      onDateChange={onFromDateChange}
      selectedDate={selectedFromDate}
      dataTestId="date-range-picker-from"
      unrestricted={unrestricted}
    />
    <div className="my-2 mx-2 font-semibold">To</div>
    <CustomDatePicker
      onClick={onClick}
      onDateChange={onToDateChange}
      selectedDate={selectedToDate}
      disabledDays={{ before: selectedFromDate }}
      dataTestId="date-range-picker-to"
      unrestricted={unrestricted}
    />
  </div>
);
